import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { STAGE_FLOW2 } from '../../../reports/flowTransactionReportSum';

const GeniusDatagrid = ({
  onDoubleClick,
  rowID,
  columns, getRowStyleCondition, // 👈 pass function from parent,
  list,
  editCell,
  onRowClick,
  dataGridHeader,
  showPagination,
  rowBgColor = '#ffffff',
  rowTextColor = '#000000',
}) => {
  return (
    <div className="h-full w-full  rounded-t-sm oveflow-hidden">
      {' '}
      <DataGrid
        hideFooterPagination={showPagination ? false : true}
        rowHeight={35}
        onRowClick={onRowClick}
        showCellRightBorder={true}
        showColumnRightBorder={true}
        disableColumnMenu={true}
        hideFooter={showPagination ? false : true}
        onCellDoubleClick={onDoubleClick && onDoubleClick}
        getRowId={rowID}
        getRowClassName={(params) => {
          if (getRowStyleCondition) {
            return getRowStyleCondition(params.row);
          }
          return '';
        }}
        headerHeight={!dataGridHeader ? 0 : 50}
        columnThreshold={2}
        components={
          !dataGridHeader
            ? {
                Header: () => {
                  const headerDetails = columns;
                  return (
                    <div className="bg-[rgb(56,53,53)] w-full  rounded-sm  rounded-b-none flex overflow-hidden    ">
                      {headerDetails?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className=" text-white flex justify-center items-center whitespace-nowrap py-3 px-3 "
                            style={
                              item.flex
                                ? index < headerDetails.length - 1
                                  ? {
                                      flex: item.flex,
                                      borderRight: '1px solid #4a4948',
                                      borderBottom: '1px solid #4a4948',
                                    }
                                  : {
                                      flex: item.flex,
                                      borderBottom: '1px solid #4a4948',
                                    }
                                : index < headerDetails.length - 1
                                ? {
                                    width: item.width,

                                    borderRight: '1px solid white',
                                    borderBottom: '1px solid #4a4948',
                                  }
                                : {
                                    width: item.width,
                                    borderBottom: '1px solid #4a4948',
                                  }
                            }
                          >
                            {item.renderHeader()}
                          </div>
                        );
                      })}
                    </div>
                  );
                },
                NoRowsOverlay: () => {
                  return (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                      }}
                    >
                      No Records Found
                    </div>
                  );
                },
              }
            : {
                NoRowsOverlay: () => {
                  return (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                      }}
                    >
                      No Records Found
                    </div>
                  );
                },
              }
        }
        sx={{
          ...(window.innerWidth < 770
            ? { fontSize: 11 }
            : window.innerWidth <= 1280
            ? { fontSize: 14 }
            : { fontSize: 13 }),
        
          borderRadius: 2,
        
          '& .MuiDataGrid-columnHeadersInner': {
            borderRight: `1px solid #4a4948`,
            backgroundColor: '#353232',
            color: '#ffffff',
          },
        
          '& .custom-row': {
            backgroundColor: rowBgColor,
            color: rowTextColor,
          },
        
          '& .custom-row:hover': {
            backgroundColor: rowBgColor,
          },
        
          // 👇 Dynamic stage styles
          ...Object.fromEntries(
            STAGE_FLOW2.map((stage) => [
              `& .stage-row-${stage.direction}`,
              {
                backgroundColor: stage.bg,
                color: stage.color,
        
                '&:hover': {
                  backgroundColor: stage.bg,
                },
        
                '& .MuiDataGrid-cell': {
                  borderColor: '#e5e7eb',
                },
              },
            ])
          ),
        }}
        columns={columns}
        rows={list}
        scrollbarSize={0}
        pageSize={100}
        rowsPerPageOptions={[100]}
        disableColumnSelector
        disableColumnReorder
        onCellEditCommit={editCell && editCell}
      />
    </div>
  );
};

export default GeniusDatagrid;
